<section class="mx-auto w-full max-w-6xl p-4 sm:p-6">
  <div class="mb-6">
    <h1 class="text-2xl font-semibold text-slate900">Input Reusable Demo</h1>
    <p class="mt-1 text-sm text-slate600">Size variants for the reusable input, followed by the existing validation demo.</p>
  </div>

  <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
    <section class="rounded-2xl border border-dashed border-violet300 bg-white p-4 sm:p-5">
      <h2 class="text-xl font-semibold text-slate900">Input Fields lg</h2>
      <div class="mt-5 space-y-4">
        <app-input-reusable
          size="lg"
          type="text"
          label="Label"
          placeholder="Placeholder"
          [control]="showcaseLgText"
          [required]="true"
          >
          <span prefix-icon class="text-xs">Aa</span>
        </app-input-reusable>

        <app-input-reusable
          size="lg"
          type="email"
          label="Label"
          placeholder="Placeholder"
          [control]="showcaseLgEmail"
          [required]="true"
          >
          <span suffix-icon class="text-xs">@</span>
        </app-input-reusable>

        <app-input-reusable
          size="lg"
          type="password"
          label="Label"
          placeholder="Placeholder"
          [control]="showcaseLgPassword"
          [required]="true"
        ></app-input-reusable>
      </div>
    </section>

    <section class="rounded-2xl border border-dashed border-violet300 bg-white p-4 sm:p-5">
      <h2 class="text-xl font-semibold text-slate900">Input Fields md</h2>
      <div class="mt-5 space-y-4">
        <app-input-reusable
          size="md"
          type="text"
          label="Label"
          placeholder="Placeholder"
          [control]="showcaseMdText"
          [required]="true"
          >
          <span prefix-icon class="text-xs">Aa</span>
        </app-input-reusable>

        <app-input-reusable
          size="md"
          type="email"
          label="Label"
          placeholder="Placeholder"
          [control]="showcaseMdEmail"
          [required]="true"
          >
          <span suffix-icon class="text-xs">@</span>
        </app-input-reusable>

        <app-input-reusable
          size="md"
          type="password"
          label="Label"
          placeholder="Placeholder"
          [control]="showcaseMdPassword"
          [required]="true"
        ></app-input-reusable>
      </div>
    </section>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" class="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
    <app-input-reusable
      type="text"
      label="Text"
      placeholder="Enter full name"
      inputId="demo-text-input"
      testId="demo-text-input"
      [control]="form.controls.text"
      [required]="true"
      >
      <span prefix-icon class="text-xs">Aa</span>
    </app-input-reusable>

    <app-input-reusable
      type="email"
      label="Email"
      placeholder="name@company.com"
      inputId="demo-email-input"
      testId="demo-email-input"
      [control]="form.controls.email"
      [required]="true"
      >
      <span suffix-icon class="text-xs">@</span>
    </app-input-reusable>

    <app-input-reusable
      type="password"
      label="Password"
      placeholder="Minimum 8 characters"
      inputId="demo-password-input"
      testId="demo-password-input"
      [control]="form.controls.password"
      [required]="true"
    ></app-input-reusable>

    <app-input-reusable
      type="number"
      label="Number"
      placeholder="Example: 12500"
      inputId="demo-number-input"
      testId="demo-number-input"
      [control]="form.controls.number"
      [required]="true"
    ></app-input-reusable>

    <app-input-reusable
      type="search"
      label="Search"
      placeholder="Search products"
      inputId="demo-search-input"
      testId="demo-search-input"
      [control]="form.controls.search"
      >
      <span prefix-icon class="text-xs">S</span>
    </app-input-reusable>

    <app-input-reusable
      type="tel"
      label="Phone"
      placeholder="+44 7700 900123"
      inputId="demo-phone-input"
      testId="demo-phone-input"
      [control]="form.controls.tel"
    ></app-input-reusable>

    <app-input-reusable
      type="url"
      label="Website"
      placeholder="https://example.com"
      inputId="demo-website-input"
      testId="demo-website-input"
      [control]="form.controls.url"
      >
      <span suffix-icon class="text-xs">link</span>
    </app-input-reusable>

    <app-input-reusable
      type="date"
      label="Date"
      placeholder="Choose date"
      inputId="demo-date-input"
      testId="demo-date-input"
      [control]="form.controls.date"
    ></app-input-reusable>

    <app-input-reusable
      type="time"
      label="Time"
      placeholder="Choose time"
      inputId="demo-time-input"
      testId="demo-time-input"
      [control]="form.controls.time"
    ></app-input-reusable>

    <app-input-reusable
      class="md:col-span-2"
      type="textarea"
      label="Textarea"
      placeholder="Write at least 10 characters"
      inputId="demo-textarea-input"
      testId="demo-textarea-input"
      [control]="form.controls.textarea"
      [required]="true"
    ></app-input-reusable>

    <app-input-reusable
      type="text"
      label="Readonly Example"
      placeholder="Readonly"
      inputId="demo-readonly-input"
      testId="demo-readonly-input"
      [control]="form.controls.readonlyExample"
      [readonly]="true"
    ></app-input-reusable>

    <app-input-reusable
      type="text"
      label="Disabled Example"
      placeholder="Disabled"
      inputId="demo-disabled-input"
      testId="demo-disabled-input"
      [control]="form.controls.disabledExample"
      [disabled]="true"
    ></app-input-reusable>

    <div class="md:col-span-2 mt-2 flex flex-wrap items-center gap-3">
      <button
        type="submit"
        class="rounded-lg bg-blue600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue700 focus:outline-none"
        >
        Submit
      </button>
      <button
        type="button"
        (click)="reset()"
        class="rounded-lg border border-slate300 bg-white px-4 py-2 text-sm font-medium text-slate700 transition hover:bg-slate100 focus:outline-none"
        >
        Reset
      </button>
      @if (form.invalid) {
        <span class="text-xs text-red600">Form has validation errors.</span>
      }
      @if (form.valid) {
        <span class="text-xs text-green700">Form is valid.</span>
      }
    </div>
  </form>

  <div class="mt-6 rounded-lg border border-slate200 bg-slate50 p-4">
    <h2 class="mb-2 text-sm font-semibold text-slate800">Form Raw Value</h2>
    <pre class="overflow-x-auto text-xs text-slate700">{{ submittedJson }}</pre>
  </div>
</section>
